export interface OBLayoutStore {
  title: string;
  subTitle: string;
}

export const obLayoutStore: (state) => OBLayoutStore = state => {
  const { onBoardingUI } = state;
  return {
    title: onBoardingUI.title,
    subTitle: onBoardingUI.subTitle
  };
};
